import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SwUpdate } from '@angular/service-worker';

// Services
import { LoaderService } from '../../services/loader/loader.service';
import { LoggerService } from '../../services/logger/logger.service';
import { TranslationService } from '../../services/translation/translation.service';
import { PwaService } from '../../services/pwa/pwa.service';

// Environment
import { environment } from '../../../../environments/environment';

export const PwaGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let alreadyFired: boolean;
  const logger = inject(LoggerService);
  const swUpdate = inject(SwUpdate);
  const loaders = inject(LoaderService);
  const translate = inject(TranslationService);
  const pwa = inject(PwaService);

  return new Observable((observer) => {
    if (environment.production) {
      pwa.checkPwa();

      logger.consoleLog('PwaGuard', 'canActivate', { isEnabled: swUpdate.isEnabled });

      if (swUpdate.isEnabled) {
        swUpdate.versionUpdates.subscribe({
          next: (newUpdate) => {
            logger.consoleLog('PwaGuard', 'activateUpdate: ' + new Date().toISOString(), newUpdate);

            if (newUpdate.type === 'VERSION_READY') {
              if (!alreadyFired) {
                alreadyFired = true;
                void loaders.present(translate.instant('PWA.NEW_VERSION'), false).then(() => {
                  setTimeout(() => {
                    loaders.dismiss();

                    alreadyFired = false;
                    window.location.reload();
                  }, 1250);
                });
              }
            }
          },
        });

        void swUpdate.checkForUpdate();
      }
    } else {
      logger.consoleLog('PwaGuard', 'canActivate', 'NOT PRODUCTION');
    }

    observer.next(true);
  });
};
